import { render, staticRenderFns } from "./ModalCertificadosVencimento.vue?vue&type=template&id=08d336a3&scoped=true"
import script from "./ModalCertificadosVencimento.vue?vue&type=script&lang=js"
export * from "./ModalCertificadosVencimento.vue?vue&type=script&lang=js"
import style0 from "./ModalCertificadosVencimento.vue?vue&type=style&index=0&id=08d336a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d336a3",
  null
  
)

export default component.exports